import { createSlice } from '@reduxjs/toolkit';

export const initialState = {
    company: [],
    simcard: {},
    device: {},
    update: [],
    contract: []
};

const adminSlice = createSlice({
    name: 'Admin',
    initialState,
    reducers: {
        getAdminCompanySuccess(state, action) {
            console.log("getAdminCompanySuccess", action.payload);
            return {
                ...state,
                company: [...action.payload.companies]
            };
        },
        updateAdminCompanySuccess(state, action) {
            console.log("updateAdminCompanySuccess", action.payload);
            const updatedCompany = action.payload;
            return {
                ...state,
                company: state.company.map(company => 
                  company.id === updatedCompany.id 
                    ? { ...company, ...updatedCompany } 
                    : company
                ),
            };
        },
        createAdminCompanySuccess(state, action) {
            console.log("createAdminCompanySuccess", action.payload);
            const newCompany = action.payload;
            return {
                ...state,
                company: [newCompany, ...state.company]
            }
        },
        getAdminCompanySimSuccess(state, action) {
            console.log("getAdminCompanySimSuccess", action.payload);
            return {
                ...state,
                simcard: {...action.payload}
            };
        },
        createAdminCompanySimSuccess(state, action) {
            console.log("createAdminCompanySimSuccess", action.payload);
            const newSim = action.payload;
            return {
                ...state,
                simcard: {
                    ...state.simcard,
                    [newSim.admin_company_id]: [
                        ...(state.simcard[newSim.admin_company_id] || []),
                        newSim
                    ]
                }
            }
        },
        updateAdminCompanySimSuccess(state, action) {
            console.log("updateAdminCompanySimSuccess", action.payload);
            const updatedSim = action.payload;
            return {
                ...state,
                simcard: {
                    ...state.simcard,
                    [updatedSim.admin_company_id]: state.simcard[updatedSim.admin_company_id] !== undefined? state.simcard[updatedSim.admin_company_id].map(simcard => 
                        simcard.id === updatedSim.id 
                          ? { ...simcard, ...updatedSim } 
                          : simcard
                    ):[updatedSim],
                }
            };
        },
        getAdminCompanyDeviceSuccess(state, action) {
            console.log("getAdminCompanyDeviceSuccess", action.payload);
            return {
                ...state,
                device: {...action.payload}
            };
        },
        createAdminCompanyDeviceSuccess(state, action) {
            console.log("createAdminCompanyDeviceSuccess", action.payload);
            const newDevice = action.payload;
            return {
                ...state,
                device: {
                    ...state.device,
                    [newDevice.admin_company_id]: [
                        ...(state.device[newDevice.admin_company_id] || []),
                        newDevice
                    ]
                }
            }
        },
        updateAdminCompanyDeviceSuccess(state, action) {
            console.log("updateAdminCompanyDeviceSuccess", action.payload);
            const updatedDevice = action.payload;
            return {
                ...state,
                device: {
                    ...state.device,
                    [updatedDevice.admin_company_id]: state.device[updatedDevice.admin_company_id] !== undefined? state.device[updatedDevice.admin_company_id].map(device => 
                        device.id === updatedDevice.id 
                          ? { ...device, ...updatedDevice } 
                          : device
                    ):[updatedDevice],
                }
            };
        },
        getAdminCompanyDeviceRecordSuccess(state, action) {
            console.log("getAdminCompanyDeviceRecordSuccess", action.payload);
            return {
                ...state,
                update: [...action.payload]
            };
        },
        getAdminCompanyDeviceContractSuccess(state, action) {
            console.log("getAdminCompanyDeviceContractSuccess", action.payload);
            return {
                ...state,
                contract: [...action.payload]
            };
        },
        resetState: () => initialState
    }
});

export const { getAdminCompanyDeviceContractSuccess, getAdminCompanyDeviceRecordSuccess, updateAdminCompanyDeviceSuccess, createAdminCompanyDeviceSuccess, getAdminCompanyDeviceSuccess, updateAdminCompanySimSuccess, createAdminCompanySimSuccess, getAdminCompanySuccess, updateAdminCompanySuccess, createAdminCompanySuccess, getAdminCompanySimSuccess, resetState } = adminSlice.actions;

export default adminSlice.reducer;
